import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Chapter } from "./shared";

const FAQS = [
  {
    q: "Does the Growth plan include a new website, or just SEO?",
    a: "Both. Growth includes a new lead capture website plus ongoing Google Business Profile management and local SEO, all in one plan.",
  },
  {
    q: "How long does setup take?",
    a: "Your new lead capture website typically launches within two weeks. We typically get Google to start indexing your new site within a week or two.",
  },
  {
    q: "Do you require a long-term contract?",
    a: "The website build is a one-time project. Ongoing hosting, content updates, support, and Google search optimization management is month to month. Cancel anytime. We provide a 2 month discount for hosting & support if you pay annually.",
  },
  {
    q: "How much do custom tools or AI automation cost?",
    a: "Every custom project is scoped and quoted individually based on what you need. Reach out and we'll put together a proposal.",
  },
  {
    q: "How do I make changes to my new website?",
    a: "Of course you will need to change/add services, pricing, or whatever on your website over time. Simply email or text us with what you need, and we will take care of it. Our annual hosting and support includes content updates!",
  },
];

const Faq = () => (
  <section id="faq" className="py-16 sm:py-24 lg:py-28 bg-white border-y border-[#e7e1d6]">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center flex flex-col items-center gap-4 mb-12">
        <Chapter num="05" label="Questions" />
        <Reveal delay={0.1}>
          <h2 className="text-3xl sm:text-4xl font-serif font-normal tracking-tight text-[#16324a]">
            Frequently Asked
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-[#e7e1d6]"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="text-left font-serif text-lg sm:text-xl font-medium text-[#16324a] hover:text-[#c99a43] hover:no-underline py-5 transition-colors duration-300"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#334e68] leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
